import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Box, Button, FormControlLabel, Grid, Switch, TextField, Typography } from '@material-ui/core';
import feathersServices from '../../../services/feathersServices';

function CategoryManagementForm(props) {
  const { onClose, onSave, selectedElement, industry, classes } = props;

  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState('');
  const [belongsTo, setBelongsTo] = useState('');
  const [fixedScoringWeight, setFixedScoringWeight] = useState(null);
  const [active, setActive] = useState(true);

  useEffect(() => {
    if (selectedElement) {
      setTitle(selectedElement.title);
      setDescription(selectedElement.description);
      setActive(selectedElement.active);
      setFixedScoringWeight(selectedElement.fixedScoringWeight);
      setBelongsTo(selectedElement.belongsTo);
    }
  }, [selectedElement]);

  const handleSave = async () => {
    if (selectedElement?._id) {
      await props.saveCategory(selectedElement._id, {
        title,
        description,
        active,
        fixedScoringWeight,
        belongsTo
      });
    } else {
      await props.createCategory({
        title,
        description,
        active,
        industry: industry._id,
        fixedScoringWeight,
        belongsTo
      });
    }
    onSave();
    onClose();
  };

  return (
    <>
      <Box className={classes.header} display="flex" alignItems="center" p={2} mb={2}>
        <Typography variant="h5" color="primary">
          {selectedElement?.title || 'Add new category'}
        </Typography>
      </Box>
      <Box display="flex" flexDirection="column" justifyContent="space-between" p={2} height={1}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField required disabled={true} defaultValue={industry.title} color="secondary" label="Industry" fullWidth variant="outlined" />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              value={title || ''}
              color="secondary"
              label="Title"
              fullWidth
              error={title === ''}
              variant="outlined"
              onChange={({ target }) => setTitle(target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              value={description}
              multiline
              minRows={4}
              maxRows={4}
              color="secondary"
              label="Description"
              fullWidth
              variant="outlined"
              onChange={({ target }) => setDescription(target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              value={belongsTo}
              color="secondary"
              label="Belongs to"
              required
              fullWidth
              variant="outlined"
              onChange={({ target }) => setBelongsTo(target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              value={fixedScoringWeight || ''}
              color="secondary"
              label="Fixed scoring weight"
              fullWidth
              type="number"
              variant="outlined"
              onChange={({ target }) => setFixedScoringWeight(target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <Box
              display="flex"
              p={1}
              border="1px solid"
              borderColor="grey.400"
              alignItems="center"
              borderRadius="borderRadius"
              className={classes.fieldset}
            >
              <FormControlLabel
                control={<Switch checked={active} onChange={({ target }) => setActive(target.checked)} />}
                labelPlacement="start"
                label="Status"
              />
              &nbsp;&nbsp;
              <Typography component="span">{active ? 'Active' : 'Disabled'}</Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid container justifyContent="flex-end">
          <Button onClick={onClose}>Cancel</Button>
          &nbsp;
          <Button disabled={!title || !belongsTo} onClick={handleSave} color="secondary" variant="contained" disableElevation>
            {selectedElement ? 'Update' : 'Create'}
          </Button>
        </Grid>
      </Box>
    </>
  );
}

const mapDispatchToProps = {
  saveCategory: feathersServices.categories.patch,
  createCategory: feathersServices.categories.create
};

export default connect(null, mapDispatchToProps)(CategoryManagementForm);
